export class EmailDomainDialogController {
    /* @ngInject */
    constructor(passwordCredentialsService, destinationService, $log) {
        this.passwordCredentialsService = passwordCredentialsService;
        this.destinationService = destinationService;
        this.$log = $log;
    }

    $onInit() {
        this.passwordCredentialsService.getUserSecurityContext()
            .then(userSecurityContext => this.userSecurityContext = userSecurityContext)
            .catch(error => this.$log.error(error));
    }
}

export let EmailDomainDialogComponent = {
    controller: EmailDomainDialogController,
    controllerAs: 'vm',
    templateUrl: 'app/login/email/EmailDomainDialogComponent.html',
    bindings: {
        destinationOrganization: '<'
    }
};
